<template>
    <div class="form-reg">
        <div class="form-reg-header">
            <span>¡Bienvenido Voluntario Inspirador!
                <br />Registra aquí tu información
            </span>
        </div>
        <div class="form-reg-container">
            <Registrar />
        </div>
    </div>
</template>

<script>
import Registrar from '../../views/inspiradores/Registrar'

export default {
  components: { Registrar }
}

</script>
<style lang="scss" scoped>
.form-reg{
    width: 100%;
    @media (min-width: 768px) {
        height: 100vh;
    }
    overflow: auto;
    .form-reg-header {
        padding: 0 5%;
        @media (min-width: 768px) {
            position: absolute;
            min-height: 180px;
            padding-top: 25px;
            padding-right: 221px;
        }
        background: #fff;
        z-index: 2;
        width: 100%;
        display: flex;
        padding-bottom: 30px;
        box-shadow: 0 10px 20px rgba(0,0,0,.12), 0 4px 8px rgba(0,0,0,.06);
        & span {
            align-self: flex-end;
            font-size: 30px;
        }
    }
    .form-reg-container{
        margin-bottom: 30px;
        margin-top: 30px;
        height: 50vh;
        @media (min-width: 803px) and (max-width: 768px) {
            margin-top: 275px;
            height: auto;
        }
        @media (min-width: 804px) {
            margin-top: 230px;
            height: auto;
        }
        padding: 0 5%;
    }
}
</style>
